export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES';
export const CHANGE_USER_PREFERENCE = 'CHANGE_USER_PREFERENCE';